import { createFormData } from 'infra/helpers/createFormData';
import { useMutation } from "react-query";
import http from "infra/http";
import { MensagemForm } from "../typings";

function useSaveMensagem() {
  return useMutation(
    (data: MensagemForm) => {
      const formData = createFormData(data.anexos || [], data, 'files', 'anexos')

      return http.post(`/v1/mensagem`, formData);
    },
    { retry: false }
  );
}

export default useSaveMensagem;
